// import ScrollTrigger from '@terwanerik/scrolltrigger';
import easing from 'jquery.easing';
// import simpleParallax from 'simple-parallax-js';
import { gsap } from "gsap";
import Swiper from 'swiper';
import swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import imagesLoaded from 'imagesloaded';
import axios from 'axios';

export class App {
  constructor(){
    this.body = document.body;
    this.page = document.getElementById('site');
    this.ua = isSp(this);
    this.speed = 900;
    this.ease = "easeInOutExpo";
    this.btn_jud = false;
    this.jud_num = 50;
    this.heroContainer = document.querySelector('.heroContainer')
    this.sliderContainer = document.getElementById('sliderContainer')
    this.article = document.getElementById('article')
    this.secContainer = document.querySelector('.secContainer')


    gsap.registerPlugin(ScrollTrigger)


    function isSp(_t){
    let _ua_ar=[];
    let _ua;
    if(navigator.userAgent.match(/iPhone|iPad|iPod|Android.+Mobile/)){
      _ua_ar.push("mobile");
      _ua = "mobile";
      if(navigator.userAgent.match(/iPhone|iPod|Android.+Mobile/)){
        _ua_ar.push("m_sp");
      }
      if(navigator.userAgent.match(/iPad/)){
        // _ua_ar.push("m_pd");
      }
      // _t.makeSp();
      //console.log(_t);
      console.log(navigator.userAgent);
    }else{
      _ua = "other";
      _ua_ar.push("other");
    }
    _ua_ar.forEach(_u => {
      _t.body.classList.add(_u);
    });
    //_t.body.classList.add(_ua_ar);
    return _ua;
  }

    this.load();

  }
  load(){
    const that = this;
    console.log('load')
    axios.get("https://soleil-park.jp/wp-json/wp/v2/pages?slug=park-wedding-page&_fields=acf&acf_format=standard")
    .then(
      response => {
        console.log(response.data[0].acf)
        
        //top
        this.acf = response.data[0].acf
        // console.log(this.acf);
        this.topSlide = this.acf.top_slide
        const set_top = this.acf.top_setting
        let _tophtml = `<div class="swiper swp top_sw load" data-speed="${set_top.speed}" data-delay="${set_top.delay}" data-mode="${set_top.mode}"><div class="swiper-wrapper">`;
        this.topSlide.forEach(
          _sl => {
            _tophtml += `<div class="swiper-slide item"><img src=${_sl.image}" ></div>`
          }
        )
        _tophtml += `</div></div>`
        this.sliderContainer.innerHTML = _tophtml


        //sections
        this.sections = this.acf.sections;
        let _html = '';
        // const ids = [];
        this.sections.forEach(
          _val => {
            // let _id;
            // if(ids.includes(_val.id)){
            //   // _id = _val.id+
            // }
            // ids.push(_val.id)
            
            if(_val.type_broken){
              const _rv = _val.reverse ? 'rv' : 'nrm';
              const _cl = `sec ${_val.id} brk ${_rv}`;
              const _pos = _val.reverse ? 'scR' : 'scL'
              _html += `<section id="${_val.id}" class="${_cl}"><div class="sec__inner">`;

               //txt
               _html += `<div class="txtWrap"><div class="txtContainer ${_pos}"><div class="txtContainer-inner">${_val.section}</div></div></div>`
               //txt

              //slider
              _html += `<div class="sliderContainer">`;
              if(_val.slide1.length){
                const set_sl1 = _val.sl1_setting
                const _verti1 = set_sl1.vertical ? 'vertical' : 'horizontal'
                _html += `<div class="swiper swp" data-speed="${set_sl1.speed}" data-delay="${set_sl1.delay}" data-mode="${set_sl1.mode}" data-direction="${_verti1}"><div class="swiper-wrapper">`;
                _val.slide1.forEach(
                  _sl => {
                    _html += `<div class="swiper-slide item"><img src=${_sl.image}" ></div>`
                  }
                )
                _html += `</div></div>`
              }
              if(_val.slide2.length){
                const set_sl2 = _val.sl2_setting
                const _verti2 = set_sl2.vertical ? 'vertical' : 'horizontal'
                _html += `<div class="swiper swp" data-speed="${set_sl2.speed}" data-delay="${set_sl2.delay}" data-mode="${set_sl2.mode}" data-direction="${_verti2}"><div class="swiper-wrapper">`;
                _val.slide2.forEach(
                  _sl => {
                    _html += `<div class="swiper-slide item"><img src=${_sl.image}" ></div>`
                  }
                )
                _html += `</div></div>`
              }
              _html += `</div>`;
              //slider


              
              _html += `</div></section>`

            }else{
              // const _fl_cl = _val.slide1.length ? "flw" : "noimg";
              // const _not_concept = _val.id == 'concept' ? 'sec_top' : 'oytxt';
              let _fl_cl;
              let _pos = "scT"
              if(_val.slide1.length){
                 _fl_cl = "flw pos_"+_val.sl1_setting.position
                 
                 if(_val.sl1_setting.position == 'left'){
                  _pos = "scL"
                 }else{
                  _pos = "scR"
                 }
              }else{
                if(_val.id == "concept"){
                   _fl_cl = "noimg sec_top"
                }else{
                   _fl_cl = "noimg oytxt"
                }
              }
              
              _html += `<section id="${_val.id}" class="sec ${_val.id} ${_fl_cl}">`;
              _html += `<div class="sec__inner"><div class="txtContainer ${_pos}"><div class="txtContainer-inner">${_val.section}</div></div></div>`;

              
              if(_val.slide1.length){
                _html += `<div class="sliderContainer">`;
                const set_sl1 = _val.sl1_setting
                const _verti1 = set_sl1.vertical ? 'vertical' : 'horizontal'
                _html += `<div class="swiper swp" data-speed="${set_sl1.speed}" data-delay="${set_sl1.delay}" data-mode="${set_sl1.mode}" data-direction="${_verti1}"><div class="swiper-wrapper">`;
                _val.slide1.forEach(
                  _sl => {
                    _html += `<div class="swiper-slide item"><img src=${_sl.image}" ></div>`
                  }
                )
                _html += `</div></div>`
                _html += `</div>`;
              }
              
              
             

              
              _html += `</section>`
            }
          }
        )
        //console.log(_html)
        this.secContainer.innerHTML = _html

        this.init();
      }
    )
    .catch(error => console.log(error))
  }
  init(){
    console.log('init')
    
    let imgLoad = imagesLoaded(document.querySelectorAll('.swiper img'))
    //.swiper.load img にしていたが、gsapのscrollltrigerがうまくtop位置を取れないので、全swiper画像を読み込んでからにする
    const onAlways = (instance) => {
      //setTimeout(()=>{
        
        this.resize();
        // this.scroll();
        this.page.classList.add('on');
        $('.spinner').fadeOut('slow',function(){
          $(this).remove();
        });
        // document.querySelector('.hero_image').classList.add('on');
        // if(_this.body.classList.contains('home')){
        //   if(ref_jud){
        //     _this.hero_swiper.autoplay.start();
        //   }
        // }
  
        // this.trigger(); not use
        this.makeSwiper();
        this.events();
      //},100);
    }

    imgLoad.on('always', onAlways);


    

    this.animate = document.querySelector('.heroContainer__svgContainerBt animate');
    // console.log(this.animate);

    // this.trigger();

    if(this.ua !== "mobile"){
      // luxy.init({
      //  wrapper:"#site",
      //  targets:'.lxel',
      //  wrapperSpeed:0.098//0.095
      // });
    }else{
      const elm = document.querySelector('.heroImage');
      const parallaxConfig = {
      delay: 0,
      orientation: "down",
      scale: 1.3,
      overflow: false,
      //customContainer:'.sec2',
      customWrapper:".img_wrap"
      //maxTransition : 50
    };

   //const parallax_instance = new simpleParallax(elm, parallaxConfig);
   //console.log(parallax_instance);
    }


  }

  makeSwiper(){
    console.log('makeswiper')
    this.swipers = document.querySelectorAll('.swp');
   console.log(this.swipers.length);
   if(this.swipers.length > 0){
     
     
     let sw_cnt = 1;
     this.sw_arr = [];

     this.swipers.forEach(
       _swp => {
         //console.log(_swp);
         _swp.classList.add('sw'+sw_cnt);
         sw_cnt++;
       }
       
     );
     
     let sw_cnt2 = 1;
     this.swipers.forEach(
       swp => {

        let swObj = {
          speed: 1000,
          loop: true,
          allowTouchMove: true,
          slidesPerView:1,
          autoplay:{
            delay:5000,disableOnInteraction:false
          }
        }

         let _delay = 1000;
         if(swp.dataset.delay){
           _delay = swp.dataset.delay * 1000;
         }
         let _speed = 2000;
         if(swp.dataset.speed){
           _speed = swp.dataset.speed * 1000;
         }
         //console.log(_speed);
         const sl_len = document.querySelectorAll('.swiper .swiper-slide').length;
         if(sl_len == 1){
           swObj.loop = false;
           swObj.autoplay = false;
         }

         if(swp.classList.contains('fade')){
           console.log('fade');
            if(sl_len > 1){
            //console.log("len="+sl_len, "del="+_delay, "sp="+_speed);

            swObj.slidesPerView = 1;
            // swObj.parallax = true;
            swObj.speed = _speed;
            swObj.autoplay = {delay:_delay,disableOnInteraction:false};
            swObj.effect= 'fade';
            }
          }else if(swp.classList.contains('slide')){
           console.log('slide');
           if(sl_len > 1){
             swObj.slidesPerView = 1;
           // swObj.parallax = true;
           swObj.speed = _speed;
           swObj.autoplay = {delay:_delay,disableOnInteraction:false};
           swObj.effect= 'slide';
           
           }
           
         }else{
           console.log('no type');
          //  console.log(swp)
           swObj.loop = true;
           swObj.slidesPerView = 1;
          //  swObj.autoplay = false;
          if(swp.dataset.speed){
            swObj.speed = swp.dataset.speed * 1000
          }
          if(swp.dataset.delay){
            swObj.autoplay = {delay:swp.dataset.delay * 1000, disableOnInteraction:false}
          }
          if(swp.dataset.mode){
            swObj.effect = swp.dataset.mode
          }
          if(swp.dataset.mode == "slide"){
            console.log(swp.dataset.direction)
            swObj.direction = swp.dataset.direction
            // swObj.autoHeight = true
          }

           swObj.breakpoints = {
             //897:{
             //   slidesPerView:4
             // },
             // 1001:{
             //   slidesPerView:4
             // },
           };
          //  swObj.navigation = {
          //    nextEl: '.swiper-button-next',
          //    prevEl: '.swiper-button-prev'
          //  };
          //  swObj.pagination= {
          //    el: '.swiper-pagination',
          //    type: 'bullets',
          //    clickable: true
          //  };

           
           if(swp.classList.contains('list_sw')){
             console.log('list sw');
              swObj.centeredSlides = true;
             swObj.slidesPerView = 'auto';
             // swObj.spaceBetween = 80;
             swObj.speed = 1000;
             swObj.autoplay = {delay:3000,disableOnInteraction:false};
             swObj.effect='slide';
           }
           if(swp.classList.contains('spot_sw')){
             swObj.speed = 1000;
             // swObj.autoplay = {delay:5000,disableOnInteraction:false};
             swObj.effect='slide';
             // swObj.allowTouchMove = false;
             // swObj.navigation = {
             //   nextEl: '.swiper-button-next-spot',
             //   prevEl: '.swiper-button-prev-spot'
             // };

             delete swObj.pagination;
           
           }
           // const swiper = new Swiper('.swiper',swObj);
         }

        //  console.log(swObj)


         const _swiper = new Swiper('.sw'+sw_cnt2,swObj);
        //  console.log(_swiper);

         let _name = '';
         if(swp.classList.contains('spot_sw')){
           _name = 'spot_sw';
         }else{
           _name = 'sw'+sw_cnt2;
         }
         this.sw_arr[_name] = _swiper;
         // console.log(this.sw_arr);
         sw_cnt2++;
       }
     )
   }

   
 }
  anim(_t){
    const rect = _t.getBoundingClientRect();
    $('html,body').animate({
      scrollTop:rect.top
    },this.speed,this.ease);
  }
  scroll(){
    let scT = window.pageYOffset;
    // console.log(this.ua);
  }
  resize(){

    this.getSize();

  }
  getSize(){
    this.winW = window.innerWidth;
    this.winH = window.innerHeight;
  }
  events(){

    const _dts = document.querySelectorAll('.incList-dl dt');
    
    _dts.forEach(
      _dt => {
        const _btn_op = document.createElement('span')
        _btn_op.classList.add('btn_op')
        _btn_op.innerHTML = `<span class="bar"></span><span class="bar"></span>`
        _dt.appendChild(_btn_op)

        _dt.addEventListener('click', (e) => {
          const cur = e.currentTarget;
          const _dd = cur.nextElementSibling.querySelector('.listWrap')
          if(cur.classList.contains('on')){
            cur.classList.remove('on');
            _dd.style.maxHeight = 0
            _btn_op.classList.remove('on')
          }else{
            cur.classList.add('on')
            _dd.style.maxHeight = _dd.querySelector('.incList').offsetHeight+"px"
            _btn_op.classList.add('on')
          }
        });
      }
    )

    const paras = document.querySelectorAll('.para');
    const scR = document.querySelectorAll('.scR');
    const scL = document.querySelectorAll('.scL');
    const scT = document.querySelectorAll('.scT');
    const scO = document.querySelectorAll('.scO');
    
    paras.forEach(
      _p => {
        gsap.fromTo(_p.querySelector('img'), {
          y:"-20%"
        },{
          y:"0",
          ease:'none',
          scrollTrigger: {
            trigger: _p,
            start: "top bottom",
            end: "bottom top",
            scrub: 1.2
          }
        })
      }
    )

    scT.forEach(
      _sct => {
        gsap.fromTo(_sct, {
          y:"10%",
          opacity:0
        },{
          y:"0",
          opacity:1,
          delay:.2,
          duration:1,
          scrollTrigger: {
            trigger:_sct,
            start: "top bottom-=10%",
          }
        })
      }
    )
    
    scR.forEach(
      _scr => {
        gsap.fromTo(_scr, {
          x:"30",
          opacity:0
        },{
          x:"0",
          opacity:1,
          duration:1,
          scrollTrigger: {
            trigger:_scr,
            start: "top bottom-=20%",
          }
        })
      }
    )
    
    scL.forEach(
      _scl => {
        gsap.fromTo(_scl, {
          x:"-30",
          opacity:0
        },{
          x:"0",
          opacity:1,
          duration:1,
          scrollTrigger: {
            trigger:_scl,
            start: "top bottom-=20%",
          }
        })
      }
    )
    
    scO.forEach(
      _sco => {
        let _d = 0;
        if(_sco.dataset.delay){
          _d = _sco.dataset.delay;
        }

        gsap.fromTo(_sco, {
          y:20,
          opacity:0
        },{
          y:"0",
          delay:_d,
          opacity:1,
          duration:1,
          scrollTrigger: {
            trigger:_sco,
            start: "top bottom-=20%",
          }
        })
      }
    )
    
    // window.addEventListener('scroll',(e)=>{this.scroll();});
    //window.addEventListener('resize',(e)=>{this.resize();});

    const atags = document.querySelectorAll("a[href^='#']");
    for(const _a of atags){
      _a.addEventListener('click',(e)=>{
        e.preventDefault();
        let href = e.currentTarget.getAttribute('href');
        if(href == "#" || href == ""){
          href = "#page";
          this.speed = 1200;
        }
        href = href.replace("#","");
        const target = document.getElementById(href);
        setTimeout((e)=>{
          this.anim(target);
        },100);
      });
    }

    const acs = document.querySelectorAll('.ac .title');
    
  }
  trigger(){
    this.trigger = new ScrollTrigger({
      trigger: {
        offset: {
          viewport: {
            x: 0,
            y: (trigger, rect, direction) => {
              return 0.1;
            }
          }
        },
        toggle: {
          callback: {
            in:(trigger)=>{
            },
            out:(trigger)=>{
            }
          }
        }
      }
    });
    this.trigger.add('[data-scroll]', {
      once: true,
      toggle: {
        class: {
          in: 'animIn',
          out: 'animOut'
        },
        callback: {
          in:(trigger) => {
            // if(trigger.element.classList.contains('img_circle')){
            //   setTimeout((e) => {
            //     console.log('beginElement');
            //     this.animate.beginElement();
            //     document.getElementById('img_circle').classList.add('on');
            //   },200);
            // }
          },
          out:(trigger) => {

          }
        }
      }
    })
  }
  makeSp(){
    const btnby = document.querySelector('.btn_buy');
    const buUrl = btnby.getAttribute('href');
    this.btn_sp = document.createElement('a');
    this.btn_sp.classList.add('btnSp');
    this.btn_sp.setAttribute('href',buUrl);
    this.btn_sp.setAttribute('target','_blank');
    this.btn_sp.innerHTML = `<div class='btnSp-inner'>
    <span class="cart"><img src="images/img_btn_under_cart.png"></span>
    <span class="text"><img src="images/img_btn_under_text.png" ></span>
    </div>`;
    this.body.appendChild(this.btn_sp);
  }
}
